/* eslint-disable @atlassian/i18n/no-literal-string-in-jsx */
import type { PostOfficeContextConfig as Context } from '@atlassian/post-office-context/types';
import { createPlacementComponent } from '@post-office/placement-common/utils/create-placement-component';
import { createUsePlacement, useInitialData } from '@post-office/placement-contexts/hooks';

import { PLACEMENT_ID } from '../__generated__/common';
import { withWacGlobalNavProductRecommendationIntlProvider } from '../__generated__/intl-provider';
import type {
	WacGlobalNavProductRecommendationAdditionalData,
	WacGlobalNavProductRecommendationInitialData,
} from '../api/types';
import { type Placement as WacGlobalNavProductRecommendationPlacement } from '../contracts/Placement';
import { type Fetcher } from '@atlassian/post-office-placement-data/types';
import { type OnPerformanceTrackingEvent } from '@post-office/placement-contexts/create-placement-component/hooks/usePerformanceTracking/types';
import {
	type ContextWithRoute,
	type FallbackRenderFacade,
} from '@post-office/placement-contexts/create-placement-component/types';
import { type ComponentType } from 'react';
import { type ErrorBoundaryPropsWithRender } from 'react-error-boundary';

const useWacGlobalNavProductRecommendationData = createUsePlacement(PLACEMENT_ID);

export const WacGlobalNavProductRecommendationPlacementComponent: ComponentType<
	Partial<ErrorBoundaryPropsWithRender> & {
		context: ContextWithRoute;
		initialData: Promise<Response | undefined> | undefined;
		fetch?: Fetcher;
		onEvent?: OnPerformanceTrackingEvent;
	} & WacGlobalNavProductRecommendationPlacement &
		FallbackRenderFacade & {
			messages?: {
				[x: string]: string;
			};
		}
> = withWacGlobalNavProductRecommendationIntlProvider(
	createPlacementComponent<WacGlobalNavProductRecommendationPlacement>(
		PLACEMENT_ID,
		({ context, initialData, zooName }) => {
			const initialDataState =
				useInitialData<WacGlobalNavProductRecommendationInitialData>(initialData);

			if (initialDataState.isLoading) {
				return <p>Loading</p>;
			}

			const additionalDataState = useWacGlobalNavProductRecommendationData<
				WacGlobalNavProductRecommendationAdditionalData,
				Context
			>('/additional-data', context);

			if (additionalDataState.isLoading || additionalDataState.error) {
				return <p>Loading or Error</p>;
			}

			return (
				<p>
					`This ${zooName} has ${additionalDataState.data.animals.length} animals.`
				</p>
			);
		},
	),
);
